// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jg_a bhs_a bhs_j bhs_q bhs_sv bhs_sw bhs_w"};